// @flow

export default class Image {
  src: string;
  alt: string;

  /**
   * Create a new Image instance
   */
  constructor(src: string, alt: string) {
    this.src = src;
    this.alt = alt;
  }
}
